import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import * as anchor from "@project-serum/anchor";
import Divider from '@mui/material/Divider';
import { Button, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import Content from '../Content/Content';
import { useTranslation } from 'react-i18next'
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { getMint } from "../../../commands/mint/getMint"
import Countdown from 'react-countdown';
import CircularProgress from '@mui/material/CircularProgress';
import { useRouter } from 'next/router';

//
import Gallery from "./Gallery";
import ConnectWallet from "../Mint/ConnectWallet";

//
function RevealIndex(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const { wallets, wallet: selected, publicKey, signMessage } = useWallet();
    const [walletAddress, setWalletAddress] = useState<any>(null);
    const router = useRouter();

    // Get wallet address
    useEffect(() => {
        if (publicKey)
            setWalletAddress(publicKey.toBase58());
        else
            setWalletAddress(null);

    }, [publicKey]);

    //
    return (
        <Box className={props.className}>

            {!walletAddress && props.mode === 'my_gallery' &&
                <ConnectWallet ornament="/mint/Ornament_Light.png" btnTextColor="#333333" sx={{ marginTop: "120px" }} textColor="#d9d9d9" header="See your dragons" body="Connect your wallet" />
            }

            {(walletAddress || props.mode === 'gallery') &&
                <Gallery
                    mode={props.mode}
                    setDragon={props.setDragon}
                    walletAddress={walletAddress}
                    dragons={props.dragons}
                    reloadDragons={props.reloadDragons}
                    reloadDragonsInProg={props.reloadDragonsInProg}
                    user={props.user}
                    updateQuests={props.updateQuests}
                    setUserTwitter={props.setUserTwitter}
                />}

        </Box>
    );
}


// Default style!
const RevealIndexStyled = styled(RevealIndex)({
    minHeight: "100vh",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    backgroundImage: "url(/mint/BG_Cave.png)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 60%",
    padding: "0px 5px 0px 5px"
});

// Export
export default RevealIndexStyled;